// extracted by extract-css-chunks-webpack-plugin
module.exports = {"next":"next___35BIt","prev":"prev___2yBq6"};